














































import moment from 'moment';
import { Component, Vue, Watch, Prop, VModel } from 'vue-property-decorator';

@Component
export default class DatePicker extends Vue {
    
    menu = false;
    text = "";
    currentMonth = 0;
    currentYear = 0;
    
    @VModel() innerValue!: string;
    @Prop() label!: string | undefined;
    @Prop() placeholder!: string | undefined;
    
    mounted() {
        if (!this.innerValue) {
            this.$emit("input", moment().format("YYYY-MM-01"));
        }
        this.text = moment(this.innerValue).isValid() ? moment(this.innerValue).format("MMMM YYYY") : "";
        this.currentMonth = Number(moment(this.innerValue).format("MM"));
        this.currentYear = Number(moment(this.innerValue).format("YYYY"));
    }
    
    @Watch("innerValue")
    innerValueChanged() {
        this.text = moment(this.innerValue).isValid() ? moment(this.innerValue).format("MMMM YYYY") : "";
        this.currentMonth = Number(moment(this.innerValue).format("MM"));
        this.currentYear = Number(moment(this.innerValue).format("YYYY"));
    }
    
    get years(): number[] {
        const items = [];
        for (let year = 2020; year <= new Date().getFullYear(); year++) {
            items.push(year);
        }
        return items;
    }
    
    private getMonthName(monthNumber: number) {
        return moment(new Date(2000, monthNumber - 1, 1)).format('MMMM');
    }
    
    private monthClick(monthNumber: number) {
        const year = Number(moment(this.innerValue).format("YYYY"));
        this.$emit("input", moment(new Date(year, monthNumber - 1, 1)).format("YYYY-MM-01"));
    }
    
    private yearClick(yearNumber: number) {
        const month = Number(moment(this.innerValue).format("MM"));
        this.$emit("input", moment(new Date(yearNumber, month - 1, 1)).format("YYYY-MM-01"));
    }
    
}
